import { ISODate, ISODateTime } from "@inrev/common";
import { cn } from "@portal/components/lib/utils";
import { Button, Text } from "@portal/components/primitives";
import { FC } from "react";
import { formatFromISODate } from "../../../../../utils";

type StatementDateSelectorProps = {
	onClick: () => void;
	date: ISODate | ISODateTime;
	isCurrentStatement: boolean;
};

export const StatementDateSelector: FC<StatementDateSelectorProps> = ({
	onClick,
	date,
	isCurrentStatement,
}) => {
	return (
		<Button
			variant="ghost"
			onClick={onClick}
			className={cn(
				"px-2.5 py-2.5 h-auto rounded-md border",
				isCurrentStatement
					? "bg-surface-base border-bc-strong"
					: "bg-surface-neutral border-bc-subtle hover:bg-surface-base",
			)}
		>
			<Text type="body" color={isCurrentStatement ? "primary" : "secondary"}>
				{formatFromISODate(date)}
			</Text>
		</Button>
	);
};
